import { RoutingKey } from '@swf/core/enums';
import type { MeetingBasedEventTypeId } from '@swf/generated/types/api/sports';

import { EventTypeId } from '../types/eventType';

import { isMeetingBasedEventTypeId } from './isEventTypeId';

const GREYHOUND_RACING_ROUTING_KEYS = [
  RoutingKey.SportsGreyhoundRacingMeetings,
  RoutingKey.SportsGreyhoundRacingNext,
  RoutingKey.SportsGreyhoundRacingRace,
  RoutingKey.SportsGreyhoundRacingFuture,
  RoutingKey.SportsGreyhoundRacingFutureMarket
] as const;

const HORSE_RACING_ROUTING_KEYS = [
  RoutingKey.SportsHorseRacingMeetings,
  RoutingKey.SportsHorseRacingNext,
  RoutingKey.SportsHorseRacingRace,
  RoutingKey.SportsHorseRacingFuture,
  RoutingKey.SportsHorseRacingFutureMarket
] as const;

export const isGreyhoundRacingRoutingKey = (routingKey?: RoutingKey) =>
  routingKey && (GREYHOUND_RACING_ROUTING_KEYS as unknown as RoutingKey[]).includes(routingKey);
export const isHorseRacingRoutingKey = (routingKey?: RoutingKey) =>
  routingKey && (HORSE_RACING_ROUTING_KEYS as unknown as RoutingKey[]).includes(routingKey);
export const isAnimalRacingRoutingKey = (routingKey?: RoutingKey) =>
  isGreyhoundRacingRoutingKey(routingKey) || isHorseRacingRoutingKey(routingKey);

/**
 * Takes active routing key and eventTypeId configured in Yoda and returns a meeting based eventTypeId
 */
const deriveMeetingBasedEventTypeId = (
  activeRoute?: RoutingKey,
  configuredEventTypeId?: string
): MeetingBasedEventTypeId => {
  if (configuredEventTypeId && isMeetingBasedEventTypeId(Number(configuredEventTypeId))) {
    return Number(configuredEventTypeId) as MeetingBasedEventTypeId;
  }

  if (isGreyhoundRacingRoutingKey(activeRoute)) {
    return EventTypeId.GREYHOUND_RACING;
  }

  return EventTypeId.HORSE_RACING;
};

export default deriveMeetingBasedEventTypeId;
